<template>
  <svg width="18"
       height="18"
       viewBox="0 0 18 18"
       :fill="color"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M 0 17.575 L 0 2 C 0 1.45 0.196 0.979 0.588 0.587 C 0.979 0.196 1.45 0 2 0 L 18 0 C 18.55 0 19.021 0.196 19.413 0.587 C 19.804 0.979 20 1.45 20 2 L 20 14 C 20 14.55 19.804 15.021 19.413 15.413 C 19.021 15.804 18.55 16 18 16 L 4 16 L 1.7 18.3 C 1.383 18.617 1.021 18.687 0.612 18.512 C 0.204 18.337 0 18.025 0 17.575 Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "var(--button-color)"
    }
  }
}
</script>
